/* eslint-disable max-lines-per-function */
import { Reducer } from 'redux';

import {
  SetAnalyticsSettingsSelectedCampaignIdAction,
  SetAnalyticsSettingsSelectedGroupIdAction,
  SetAnalyticsSettingsSelectedUserAction,
} from '../../domains/analyticsSettings/actions.types';

import { defaultAnalyticsSettings } from './mock';
import { AnalyticsSettings } from './types';

export type AnalyticsSettingsAction =
  | SetAnalyticsSettingsSelectedUserAction
  | SetAnalyticsSettingsSelectedGroupIdAction
  | SetAnalyticsSettingsSelectedCampaignIdAction;

const initialState = defaultAnalyticsSettings;

const reducer: Reducer<AnalyticsSettings, AnalyticsSettingsAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'ANALYTICS_SETTING_SELECTED_USER.SET':
      return { ...state, selectedOnBehalfOfUserId: action.payload.selectedOnBehalfOfUserId };
    case 'ANALYTICS_SETTING_SELECTED_GROUP.SET':
      return { ...state, selectedGroupId: action.payload.selectedGroupId };
    case 'ANALYTICS_SETTING_SELECTED_CAMPAIGN.SET':
      return { ...state, selectedCampaignId: action.payload.selectedCampaignId };
    default:
      return state;
  }
};

export default reducer;
